// The API base URL should be provided at build time via REACT_APP_API_BASE.
// See .env.example. If unset, we fall back to the live Render backend so a
// production build never silently points at localhost.
const PRODUCTION_DEFAULT = "https://alnooredtech-backend.onrender.com";

const API_BASE = process.env.REACT_APP_API_BASE || PRODUCTION_DEFAULT;

export async function createOrder(payload) {
  const resp = await fetch(`${API_BASE}/orders`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await resp.json();
  if (!resp.ok) throw new Error(data?.error || "Failed to create order");
  return data;
}

/* --------------------------------------------------
   Admin (requires a Firebase ID token from an allowlisted admin)
-------------------------------------------------- */
export async function fetchAdminOrders(idToken) {
  const resp = await fetch(`${API_BASE}/admin/orders`, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data?.error || "Failed to load orders");
  return data.orders || [];
}

export async function updateOrderStatus(idToken, orderId, orderStatus) {
  const resp = await fetch(`${API_BASE}/admin/orders/${orderId}/status`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ orderStatus }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data?.error || "Failed to update order");
  return data;
}
